export default __webpack_public_path__ + "static/media/JungleLife_04.fc01cfc5.png";